// src/authConfig.js
export const msalConfig = {
  auth: {
    clientId: "7d2c5fe8-85f8-424b-8196-e705e6a864ca",
    authority: "https://login.microsoftonline.com/52e54255-72b0-4649-951a-2de4c170009d",
    redirectUri: "https://upload.cfmu.ca",
    postLogoutRedirectUri: "https://upload.cfmu.ca",
    navigateToLoginRequestUrl: false // Prevents redirect loops
  },
  cache: {
    cacheLocation: "localStorage", // Better persistence than sessionStorage
    storeAuthStateInCookie: true, // Keep for IE11 compatibility
  },
  system: {
    allowNativeBroker: false, // Prevents native broker issues
    windowHashTimeout: 60000,
    iframeHashTimeout: 10000
  }
};

// Simple login request with SharePoint permissions
export const loginRequest = {
  scopes: [
    "User.Read", 
    "Sites.Read.All", 
    "Files.Read.All"
  ],
  prompt: "select_account"
};

// SharePoint site URL
export const sharepointSiteUrl = "https://mcmastersu.sharepoint.com/sites/CFMU-Uploads/SitePages/CollabHome.aspx";